module.exports = {
	"name": "Precipitation",
	"desc": "Total monthly rainfall in millimeters. 1950 –⁠ 2000 average.",
	"useHighResMaps": false,
	"maps": [
		{
			"name": "prec_1c",
			"displayName": "Jan."
		},
		{
			"name": "prec_2c",
			"displayName": "Feb."
		},
		{
			"name": "prec_3c",
			"displayName": "Mar."
		},
		{
			"name": "prec_4c",
			"displayName": "Apr."
		},
		{
			"name": "prec_5c",
			"displayName": "May"
		},
		{
			"name": "prec_6c",
			"displayName": "Jun."
		},
		{
			"name": "prec_7c",
			"displayName": "Jul."
		},
		{
			"name": "prec_8c",
			"displayName": "Aug."
		},
		{
			"name": "prec_9c",
			"displayName": "Sep."
		},
		{
			"name": "prec_10c",
			"displayName": "Oct."
		},
		{
			"name": "prec_11c",
			"displayName": "Nov."
		},
		{
			"name": "prec_12c",
			"displayName": "Dec."
		}
	],
	"gradientMin": "0",
	"gradientMax": "1000",
	"gradientStyle": "precipitation"
};


//////////////////
// WEBPACK FOOTER
// ./src/resources/data/precipitation-info.json
// module id = 1152
// module chunks = 0